export default __webpack_public_path__ + "media/images/hover4-2437cc3ae98ace43dbb72382296e5133.png";